import * as common from '../../../../../common'
import { ForGroup } from '../node/for-group'
import { ForRecords } from '../node/for-records'
import { ForValue } from '../node/for-value'
import type { Node } from '../node/node'

/**
 * Determines the {@link common.value.types.Type} that is expected to
 * be returned for the given {@link Node}
 */
export function getResultType(node: Node): common.value.types.Type | undefined {
  if (ForRecords.isForRecords(node)) {
    return node.selection.type
  } else if (ForValue.isForValue(node)) {
    // NOTE: hopefully the value is at least one of the raw types
    return common.value.types.Intrinsic.inferFrom(
      node.value as common.value.Raw,
    )
  } else if (ForGroup.isForGroup(node)) {
    return getResultType(node.members[0])
  }
  throw new Error(`Cannot identify result type for dms.Graph.Node: ${node.id}`)
}
